var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"svg-icon-container"},[_c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('click',_vm.icon,$event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }